import {noop} from '@logistics-frontend/utils'
import React, {useEffect} from 'react'

import {useFetchCards, useFetchCardsTransition} from '../../shared/hooks'
import {CardAddModal} from '../card-add-modal'
import {CardListModal} from '../card-list-modal'
import {BoundCardModalProps} from './BoundCardModal.types'

const BoundCardModal: React.FC<BoundCardModalProps> = ({
  scope,
  onError = noop,
  onPending = noop,
  onSuccess = noop,
  onClose = noop,
}) => {
  const {fetchCardsHandler} = useFetchCards(scope)
  const {cardsPayload, isCardsPending} = useFetchCardsTransition(scope)

  /**
   * Нужно уметь сообщать как-то наверх о том, что мы ждем ответа от сервера.
   */
  useEffect(() => {
    onPending(isCardsPending)
  }, [isCardsPending, onPending])

  /**
   * Если мы ждем ответа от сервера, то ничего не показываем.
   */
  if (isCardsPending) {
    return null
  }

  if (cardsPayload?.cards.length) {
    return <CardListModal onClose={onClose} onError={onError} onSuccess={onSuccess} scope={scope} />
  }

  return <CardAddModal onClose={onClose} onSuccess={fetchCardsHandler} scope={scope} />
}

BoundCardModal.displayName = 'BoundCardModal'

export default React.memo(BoundCardModal)
